import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import "./i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./contexts/authContext/authContext";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";
import { muiThemes } from "./mui-themes";
import { MerchantDataProvider } from "./contexts/authContext/merchantListingContext";
import ScrollToTop from "./utils/ScrollToTop";

const theme = createTheme(muiThemes);

ReactDOM.render(
	<React.StrictMode>
		<BrowserRouter>
			<ScrollToTop />
			<AuthProvider>
				<ThemeProvider theme={theme}>
					<App />
				</ThemeProvider>
			</AuthProvider>
		</BrowserRouter>
	</React.StrictMode>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
